export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setUnread(state, payload) {
    state.unreadCount = payload;
  },
  setUnreadMes(state, payload) {
    state.unreadMes = payload;
  },
  pushNotification(state, payload) {
    const orderId = payload.key_id || payload.data_id;
    if (
      orderId &&
      state.notifications.some(
        (item) => String(item.key_id || item.data_id) === String(orderId)
      )
    ) {
      return;
    }

    state.notifications.unshift({
      key_id: payload.key_id,
      key: payload.key || "order",
      data_id: payload.data_id || payload.key_id,
      title: payload.title,
      body: payload.body,
      is_readed: false,
      created_time: payload.created_time || null,
    });
    ++state.unreadCount;
    ++state.unreadMes;
  },
  decreaseCounter(state) {
    --state.unreadMes;
  },
  triggerOrderRefresh(state, orderId) {
    state.orderRefreshTrigger = Date.now();
    if (orderId) {
      state.lastNewOrderId = orderId;
    }
  },
};
